import { useContext } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import { useGetAppConnectionsCount } from "src/services/organizations/queries/count";
import { GetConnectionsCount } from "src/services/organizations/queries/NetTypes";

import { useGetApp } from "../../AppSettings/Details/hook/useGetApp";
import Context from "../context";

// ----------------------------------------------------------------------

export const useGetStatisticsData = () => {
	const { product } = useContext(Context);

	const app = useGetApp();
	const org = useGetOrg();

	const { data } = useGetAppConnectionsCount(org.id, app?.id ?? "", product);

	const { current, variation } = data as GetConnectionsCount;

	const total = current
		.filter((i) => i.status !== "DELETED")
		.reduce((acc, item) => acc + item.count, 0);

	return { mtd: variation.mtd, ytd: variation.ytd, day: variation.day, total };
};

export default useGetStatisticsData;
